
export default {
  inject: ['product', 'wording'],
  data() {
    return {
      product: this.product,
      wording: this.wording,
      toggled: false,
    }
  },
  computed: {
    fittingGuideIndicator() {
      if (this.product.fitting_guide === 'runs_small_size_up') return 'left'
      else if (this.product.fitting_guide === 'between_small_true')
        return 'middle-left'
      else if (this.product.fitting_guide === 'true_to_size') return 'center'
      if (this.product.fitting_guide === 'between_large_true')
        return 'middle-right'
      else if (this.product.fitting_guide === 'runs_large_size_down')
        return 'right'
      else return null
    },
    fittingGuideLabel() {
      if (this.product.fitting_guide === 'runs_small_size_up')
        return this.wording.fitting_guide_runs_small_size_up
      else if (this.product.fitting_guide === 'between_small_true')
        return this.wording.fitting_guide_between_small_true
      else if (this.product.fitting_guide === 'true_to_size')
        return this.wording.fitting_guide_true_to_size
      if (this.product.fitting_guide === 'between_large_true')
        return this.wording.fitting_guide_between_large_true
      else if (this.product.fitting_guide === 'runs_large_size_down')
        return this.wording.fitting_guide_runs_large_size_down
      else return null
    },
  },
}
